"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TooltipProps_1 = require("./TooltipProps");
var FixedTooltip_1 = require("./FixedTooltip/FixedTooltip");
var InlineTooltip_1 = require("./InlineTooltip/InlineTooltip");
var utils_1 = require("../../../utils/utils");
var index_1 = require("./PushingTooltip/index");
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        var isRennyStyle = this.props.options && this.props.options.isRennyStyle;
        if (this.props.data.type === TooltipProps_1.TooltipTypes.INLINE) {
            return (React.createElement(InlineTooltip_1.default, __assign({ testId: utils_1.default(this.props.testId, 'InlineTooltip') }, this.getInlineTooltipProps(), { options: { className: this.props.options && this.props.options.className ? this.props.options.className : '',
                    isRennyStyle: this.props.options && this.props.options.isRennyStyle } }), this.props.children));
        }
        else if (this.props.data.type === TooltipProps_1.TooltipTypes.PUSHING_CONTROLLED) {
            return (React.createElement(index_1.default, __assign({ testId: utils_1.default(this.props.testId, 'PushingTooltip') }, this.getPushingTooltipProps()), this.props.children));
        }
        else {
            return (React.createElement(FixedTooltip_1.default, __assign({ testId: utils_1.default(this.props.testId, 'FixedTooltip') }, this.getFixedTooltipProps()), this.props.children));
        }
    };
    Tooltip.prototype.getInlineTooltipProps = function () {
        return {
            data: {
                showTooltip: this.props.data.showTooltip,
            },
        };
    };
    Tooltip.prototype.getFixedTooltipProps = function () {
        var userClass = (this.props.options && this.props.options.className) ? this.props.options.className : '';
        return {
            data: {
                isControlled: this.props.data.type === TooltipProps_1.TooltipTypes.FIXED_CONTROLLED,
                showTooltip: this.props.data.showTooltip,
            },
            options: {
                className: userClass,
                growRight: this.props.options && this.props.options.growRight,
                width: this.props.options && this.props.options.width,
                isRennyStyle: this.props.options && this.props.options.isRennyStyle,
            },
        };
    };
    Tooltip.prototype.getPushingTooltipProps = function () {
        var userClass = (this.props.options && this.props.options.className) ? this.props.options.className : '';
        return {
            data: {
                isControlled: this.props.data.type === TooltipProps_1.TooltipTypes.PUSHING_CONTROLLED,
                showTooltip: this.props.data.showTooltip,
            },
            options: {
                className: userClass,
                growRight: this.props.options && this.props.options.growRight,
                width: this.props.options && this.props.options.width,
                isRennyStyle: this.props.options && this.props.options.isRennyStyle,
            },
        };
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/Tooltip.js
// module id = 936
// module chunks = 8